import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import clsx from 'clsx';
import GenericInput from '../../genericInput/GenericInput';
import inputWithHyphenStyles from './inputWithHyphen.styles';
const formatString = value => {
    if (!value?.length) {
        return '';
    }
    const val = value.replace(/-/g, '');
    return val.substring(0, val.length - 1) + '-' + val.substring(val.length - 1);
};
const InputWithHyphen = props => {
    const { label, required, id, onChange, onFocus, onBlur, value, rawErrors, disabled, schema, classes, } = props;
    const { readOnly, disabled: schemaDisabled } = schema;
    const isDisabled = disabled || schemaDisabled || readOnly;
    const currentError = useMemo(() => rawErrors?.[0] ?? undefined, [rawErrors]);
    const styles = inputWithHyphenStyles();
    const handleChange = useCallback((e) => {
        const formattedString = formatString(e.target.value);
        onChange(formattedString);
    }, [onChange]);
    const handleBlur = useCallback(() => {
        onBlur && onBlur(id, value);
    }, [onBlur, id, value]);
    const inputValue = value?.includes('-') ? value : formatString(value);
    return (_jsx(GenericInput, { label: label, required: required, id: id, onChange: handleChange, onFocus: onFocus, onBlur: handleBlur, value: inputValue, currentError: currentError
            ? {
                props: {
                    id: currentError,
                    defaultMessage: currentError,
                },
            }
            : undefined, classes: {
            dateCalendar: clsx([styles.dateCalendar, classes?.dateCalendar]),
            disabled: clsx([styles.disabled, classes?.disabled]),
            errorText: clsx([styles.errorText, classes?.errorText]),
            fieldWrapper: clsx([styles.fieldWrapper, classes?.fieldWrapper]),
            focused: clsx([styles.focused, classes?.focused]),
            helperTextError: clsx([
                styles.helperTextError,
                classes?.helperTextError,
            ]),
            input: clsx([styles.input, classes?.input]),
            inputError: clsx([styles.inputError, classes?.inputError]),
            inputNoLabel: clsx([styles.inputNoLabel, classes?.inputNoLabel]),
            label: clsx([styles.label, classes?.label]),
            labelAsterisk: clsx([styles.labelAsterisk, classes?.labelAsterisk]),
            labelContainer: clsx([styles.labelContainer, classes?.labelContainer]),
            noOptions: clsx([styles.noOptions, classes?.noOptions]),
            notchedOutline: clsx([styles.notchedOutline, classes?.notchedOutline]),
            phonePrefix: clsx([styles.phonePrefix, classes?.phonePrefix]),
            root: clsx([styles.root, classes?.root]),
        }, disabled: isDisabled }, void 0));
};
export default InputWithHyphen;
//# sourceMappingURL=InputWithHyphen.js.map